import React from 'react';
import * as styles from './Heading.module.scss';
const Heading = ({
  heading,
  variant,
  classname
}) => {
  if (!heading) {
    return null;
  }
  return heading && /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${variant ? styles[variant] : ''} ${classname || null}`
  }, heading);
};
export default Heading;